import React from 'react';
import axios from 'axios';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { isLoading } from '../../../Base/Actions';

// Import components
import LoaderView from './LoaderView';

class LoaderController extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      progress: 0,
      total: 0,
      loaded: 0,
      requestsCounter: 0,
      isLoading: false,
    };

    axios.interceptors.request.use((config) => {
      this.setState({
        progress: 40,
        requestsCounter: this.state.requestsCounter += 1,
      });
      return config;
    });
  }

  componentWillMount() {
    this.setupUpdateProgress();
    this.setupStopProgress();
  }

  setupUpdateProgress() {
    const update = (e) => {
      this.props.isLoading(true);
      const totalLength = e.lengthComputable ? e.total : e.target.getResponseHeader('content-length') || e.target.getResponseHeader('x-decompressed-content-length');

      if (totalLength !== null) {
        const total = (this.state.total + totalLength) / this.state.requestsCounter;
        const loaded = (this.state.loaded + e.loaded) / this.state.requestsCounter;
        const progress = Math.floor(loaded * 100) / total;
        this.setState({
          total,
          loaded,
          progress,
          isLoading: true,
        });
      }
    };

    axios.defaults.onDownloadProgress = update;
    axios.defaults.onUploadProgress = update;
  }

  setupStopProgress() {
    axios.interceptors.response.use((response) => {
      this.setState({
        requestsCounter: this.state.requestsCounter -= 1,
      });

      if (this.state.requestsCounter === 0) {
        this.props.isLoading(false);
        this.setState({
          progress: 0,
          isLoading: false,
        });
      }

      return response;
    }, (error) => {
      if (this.state.requestsCounter === 0) {
        this.props.isLoading(false);
        this.setState({
          progress: 0,
          isLoading: false,
        });
      }

      return Promise.reject(error);
    });
  }

  render() {
    return (
      <LoaderView loaderWidth={this.state.progress} isLoading={this.state.isLoading} />
    );
  }
}

function mapStateToProps(state) {
  return {
    error: state.globalsState.error,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ isLoading }, dispatch);
}

LoaderController.propTypes = {
  isLoading: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(LoaderController);



// WEBPACK FOOTER //
// ./frontend/js/Components/Globals/Loader/LoaderController.jsx